import { TypographyStandardTitleH2 } from "src/components/typography"

type props = {
    projectName: string,
    TotalWorkItem: number,
    completedWorkItem: number
}

export function ProjectComponent(props: props) {

    return (
        <div className='border p-2 rounded-md grid grid-cols-1  w-full md:grid-cols-5 gap-2 gap-y-4'>
            <div className='w-full flex gap-2 md:col-span-3 '>
                <TypographyStandardTitleH2>{props.projectName}</TypographyStandardTitleH2>
            </div>
            <div className=' flex col-span-1 md:col-span-2'>
                <div className=' flex flex-col w-full place-items-end'>

                    <div className='flex'>
                        <TypographyStandardTitleH2>Total Work Item: </TypographyStandardTitleH2>
                        <p className=" pl-1">{props.TotalWorkItem}</p>
                    </div>
                    <div className='flex'>
                        <TypographyStandardTitleH2>Completed Work Item: </TypographyStandardTitleH2>
                        <p className="pl-1">{props.completedWorkItem}</p>
                    </div>
                </div>
            </div>
        </div>
    )

}